import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsQiitaComponent } from './simple-icons-qiita.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsQiitaComponent ],
    exports:      [ SimpleIconsQiitaComponent ],
    bootstrap:    []
})
export class SimpleIconsQiitaModule {}
